const monthNames = {
  en: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  ar: [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر',
  ],
};

export default function formatDate(options: {
  value: string | Date;
  language?: 'en' | 'ar';
  format?: 'YYYY-MM-DD' | 'gregorian';
  removeDay?: boolean;
}): string {
  const {
    value,
    language = 'en',
    format = 'YYYY-MM-DD',
    removeDay = false,
  } = options;

  if (value) {
    const date = typeof value === 'string' ? new Date(value) : value;
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const monthFormat = (month + 1).toString().padStart(2, '0');
    const dayFormat = day.toString().padStart(2, '0');

    if (format === 'gregorian')
      return `${removeDay ? '' : day} ${monthNames[language][month]} ${year}`;

    return language === 'ar'
      ? `${year}-${monthFormat}-${dayFormat}`
      : `${dayFormat}-${monthFormat}-${year}`;
  }
  return '';
}
